export const getReferralCodeFromSearch = (search) =>
  String(new URLSearchParams(search || "").get("ref") || "").trim().toUpperCase().slice(0, 50);

export const buildReferralLink = (code, origin) =>
  `${String(origin || "").replace(/\/+$/, "")}/register?ref=${encodeURIComponent(String(code || "").trim().toUpperCase())}`;
